import { useDispatch, useSelector } from "react-redux";
import Tabs from "../../components/Tabs"; // adjust path
import { useNavigate } from "react-router-dom";
import { RootState } from "../../redux/store";
import Userlist from "./Components/Userlist";
import AgentList from "./Components/AgentList";
import ValuerList from "./Components/ValuerList";
import { setClearFilters } from "../../redux/slices/Users/slice";
import { Button } from "../../components/Button";

const Users = () => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const {
        usersList,
        filterData,
        loading,
    } = useSelector((state: RootState) => state.users);

    const tabs = [
        { id: "user", label: "Users", content: <Userlist /> },
        { id: "agent", label: "Agents", content: <AgentList /> },
        { id: "valuer", label: "Valuer", content: <ValuerList /> },
    ];

    return (
        <div>
            <Tabs
                tabs={tabs}
                defaultActive="user"
                onTabChange={(id) => {
                    dispatch(setClearFilters())
                }}
            />
        </div>
    );
};

export default Users;
